'use strict'

function navInsertCollectionLink() {
  const collectionsItem = document.querySelectorAll('li.menu-drawer__list-item.menu-drawer__list-item--flat:not([data-collection_link_insert="true"])');
  if (!collectionsItem.length) return;

  const prefix = 'HeaderDrawer-alle-kollektionen-';
  const logoMap = {
    'rolex': 'Rolex-logo.svg',
    'patek-philippe': 'Patek_Philippe-logo.svg',
    // ***
  };

  collectionsItem.forEach(item => {
    const insertContainer = item.querySelector('ul.menu-drawer__menu.menu-drawer__menu--grandchildlist.details-content');
    if (!insertContainer) return;

    const nameSource = item.querySelector('.menu-drawer__menu-item-text');
    const link = item.querySelector('a.menu-drawer__menu-item.menu-drawer__menu-item--parent');

    if (!nameSource || !link) return;

    let name = nameSource.textContent.trim();
    const href = link.href;
    const brandKey = link.id.replace(prefix, '');

    if (logoMap[brandKey]) {
      name = `<img src="/cdn/shop/collections/${logoMap[brandKey]}" alt="${name} logo">`;
    } else {
      name = `<span>${name}</span>`;
    }

    const html = `<li class="insert-collection-link"><a href="${href}">${name}</a></li>`;
    insertContainer.insertAdjacentHTML('afterbegin', html);

    item.setAttribute('data-collection_link_insert', true);

    // tmp
    const devLink = item.querySelector('a#HeaderDrawer-alle-kollektionen-devtmp');
    // console.log(devLink);
    if (!devLink) return;
    const pe = devLink.closest('li.menu-drawer__list-item.menu-drawer__list-item--flat');
    // console.log('pe', pe);
    if (pe) pe.style.display = 'none';
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, navInsertCollectionLink)
);
